import React, { useState, useRef } from 'react'
import { View, Animated, TouchableOpacity } from 'react-native'
import PropTypes from 'prop-types'
import { Card, Txt, Icon, EquipmentsSelectInput, CheckBox } from '../../../../../../components'
import { useTheme } from '../../../../../../theming/ThemeProvider'
import InputFormik from '../../../../../../components/InputFormik'
import useStyles from './useStyles'
const TractorCard = (props) => {
  const { recurringTractor, day, onChangeValue } = props

  const [open, setOpen] = useState(false)
  const [title] = useState(day.charAt(0).toUpperCase() + day.slice(1))
  const [prefixes] = useState({
    tractors: `tractors_available_${day}`,
    equipmentType: `equipment_type_id_${day}`,
    teams: `teams_${day}`
  })
  const sectionHeight = useRef(new Animated.Value(0)).current
  const { theme } = useTheme()
  const styles = useStyles(theme)

  const handleCard = () => {
    Animated.timing(sectionHeight, {
      toValue: open ? 0 : 90,
      duration: 200,
      useNativeDriver: false
    }).start()
    setOpen(!open)
  }
  return (
    <View>
      <Card containerStyle={styles.card} contentStyle={styles.cardContent}>
        <Txt
          text={title}
          identity='body2Bold'
          style={styles.day}
        />
        <View style={styles.details}>
          <View style={styles.tractors}>
            <Txt
              text={recurringTractor[prefixes.tractors]}
              identity='body2Bold'
              color='LOCHMARA'
              numberOfLines={1}
            />
            <Txt
              text='Tractors'
              identity='body2'
              color='SLATE_GRAY'
              style={styles.text}
              numberOfLines={1}
            />
          </View>
          <View style={styles.equipment}>
            <Icon
              name='Tractor2'
              height={16}
              width={16}
              fill={theme.LOCHMARA}
            />
            <Txt
              text={recurringTractor[prefixes.equipmentType] ? recurringTractor[prefixes.equipmentType].description : '- -'}
              identity='body2'
              color='SLATE_GRAY'
              style={styles.text}
            />
          </View>
          {Boolean(recurringTractor[prefixes.teams]) && (
            <View>
              <Txt
                text='Team'
                identity='body2Bold'
                color='LOCHMARA'
              />
            </View>
          )}
        </View>
        <Animated.View style={{ height: sectionHeight, overflow: 'hidden' }}>
          <View style={styles.inputsContainer}>
            <View style={styles.quantity}>
              <InputFormik
                name={prefixes.tractors}
                label='Quantity'
                placeholder='0'
                value={recurringTractor[prefixes.tractors]}
                onChange={onChangeValue}
                keyboardType='numeric'
                testID={`${day}TractorQuantityInput`}
                accessibilityLabel={`${day}TractorQuantityInput`}
              />
            </View>
            <View style={styles.equipmentType}>
              <EquipmentsSelectInput
                label='Equipment Type'
                name={prefixes.equipmentType}
                selected={recurringTractor[prefixes.equipmentType]}
                onChange={onChangeValue}
              />
            </View>
            <View style={styles.teams}>
              <Txt
                text='Team'
                identity='body3'
                style={styles.teamsLabel}
              />
              <View style={{ paddingTop: 10 }}>
                <CheckBox
                  onPress={() => onChangeValue(prefixes.teams, !recurringTractor[prefixes.teams])}
                  checked={Boolean(recurringTractor[prefixes.teams])}
                  color='GEYSER'
                />
              </View>
            </View>
          </View>
        </Animated.View>
        <View>
          <TouchableOpacity activeOpacity={0.8} onPress={handleCard} style={styles.arrow}>
            <Icon
              name={open ? 'AngleUp' : 'AngleDown'}
              fill={theme.SLATE_GRAY_TEXT}
              height={20}
              width={20}
            />
          </TouchableOpacity>
        </View>
      </Card>
    </View>
  )
}

TractorCard.propTypes = {
  recurringTractor: PropTypes.object,
  day: PropTypes.string,
  onChangeValue: PropTypes.func
}

TractorCard.defaultProps = {
  recurringTractor: {},
  day: '',
  onChangeValue: () => {}
}

export default TractorCard
